import React from 'react';
import { Alert, Button, ErrorOutlineIcon, Text } from '@billda/design-system';
import { useNavigate } from 'react-router-dom';
import { Routes as AppRoutes } from '../../../routes';

const InvitationErrorPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="mx-auto w-full max-w-[600px] px-4">
      <div className="mt-16">
        <div className="rounded-xl border border-border-default bg-surface-default p-8 text-center shadow-lg">
          <ErrorOutlineIcon
            aria-hidden="true"
            className="mb-4 size-[60px] text-content-error"
          />

          <Text as="div" variant="h5" className="mb-2 text-content-error">
            Invalid Invitation
          </Text>

          <Alert severity="error" className="mt-4 mb-6 text-left">
            This invitation link is invalid or has expired.
          </Alert>

          <Text as="div" variant="body1" color="secondary" className="mb-6">
            Possible reasons:
          </Text>

          <div className="mb-6 text-left">
            <Text as="div" variant="body2" color="secondary" className="mb-2">
              • The invitation has already been used
            </Text>
            <Text as="div" variant="body2" color="secondary" className="mb-2">
              • The invitation link has expired
            </Text>
            <Text as="div" variant="body2" color="secondary" className="mb-2">
              • The invitation was cancelled
            </Text>
            <Text as="div" variant="body2" color="secondary">
              • The link may be incomplete or incorrect
            </Text>
          </div>

          <Text as="div" variant="body2" color="secondary" className="mb-8">
            Please contact your administrator to request a new invitation.
          </Text>

          <Button
            variant="neutral"
            onClick={() => navigate(AppRoutes.root)}
            data-testid="go-to-login-button"
          >
            Go to Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InvitationErrorPage;
